import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Angle } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import DidNotFindServiceItem from '../DidNotFindServiceItem';
import DidNotFindResourceItem from '../DidNotFindResourceItem';

import './DidNotFind.scss';

export default class DidNotFind extends BcReactComponent {
  renderDidNotFindResources() {
    const { query, didNotFindOptions } = this.props;

    return didNotFindOptions
      .get('didNotFindResources')
      .map((resource) =>
        <DidNotFindResourceItem
          className="did-not-find-resource"
          key={resource.get('resourceName')}
          query={query}
          resourceName={resource.get('resourceName')}
          resourceDescription={resource.get('resourceDescription')}
          resourceTags={resource.get('resourceTags')}
          resourceLink={resource.get('resourceLink')} />
    );
  }

  renderDidNotFindServices() {
    const { didNotFindOptions } = this.props;

    return didNotFindOptions
            .get('didNotFindServices')
            .map((service) =>
              <DidNotFindServiceItem
                className="did-not-find-service"
                key={service.get('id')}
                serviceId={service.get('id')}
                serviceName={service.get('localeKey')}
                serviceLink={service.get('link')} />
            );
  }

  renderMoreResources() {
    const { didNotFindOptions } = this.props;

    return didNotFindOptions.get('additionalResourcesLink') && (
      <a className="did-not-find-additional-resources-link" href={`${didNotFindOptions.get('additionalResourcesLink')}`}>
        <span aria-hidden>
          <FormattedMessage id="view_more_resources" />
          <Angle.Right />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage id="ada_opens_a_new_tab" values={{ linkText: <FormattedMessage id="view_more_resources" /> }} />
        </ScreenReaderMessage>
      </a>
    );
  }

  render() {
    return (
      <div className="did-not-find">
        <div className="did-not-find-resources">
          <FormattedMessage id="other_resources" tagName="h3" />
          { this.renderDidNotFindResources() }
          <div className="did-not-find-more-resources">
            { this.renderMoreResources() }
          </div>
        </div>
        <div className="did-not-find-services">
          <FormattedMessage id="library_resources" tagName="h3" />
          { this.renderDidNotFindServices() }
        </div>
      </div>
    );
  }
}

DidNotFind.propTypes = {
  query: PropTypes.string,
  didNotFindOptions: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/search/DidNotFind/DidNotFind.jsx